import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import ErrorBoundary from './ErrorBoundary';
import { initTelegram } from './telegram';
import { initTheme } from './theme';
import './styles.css';

initTelegram();
// Тема ставится до первого рендера, иначе тёмный интерфейс моргает белым.
initTheme();

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
